// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import firebase from "firebase/app";
import "firebase/database";
import "firebase/analytics";
import "firebase/messaging";

import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDJi42VwYXL4ZFV5ktm_ySz0H-gBn1mBlI",
  authDomain: "pspp-project.firebaseapp.com",
  databaseURL: "https://pspp-project.firebaseio.com",
  projectId: "pspp-project",
  storageBucket: "pspp-project.appspot.com",
  messagingSenderId: "992623275810",
  appId: "1:992623275810:web:2621177c12dffcfaf67f7b",
  measurementId: "G-60WR3GHP50"
};

firebase.initializeApp(firebaseConfig);

const analytics = firebase.analytics();
const database = firebase.database();
// const messaging = firebase.messaging();

// getToken(messaging, {vapidKey: "BPI0w-9--AyHKzVkH6a8TFlw3DeMB49Xi9WmPkVrVYKvtwXTVkjB1_yWtPbdYvzN_YhV6hA9rmMRmYmajkwbSmk"});

// messaging.getToken({ vapidKey: 'BPI0w-9--AyHKzVkH6a8TFlw3DeMB49Xi9WmPkVrVYKvtwXTVkjB1_yWtPbdYvzN_YhV6hA9rmMRmYmajkwbSmk' }).then((currentToken) => {
//   if (currentToken) {
//     console.log('aa', currentToken)
//     // Send the token to your server and update the UI if necessary
//     // ...
//   } else {
//     // Show permission request UI
//     console.log('No registration token available. Request permission to generate one.');
//     // ...
//   }
// }).catch((err) => {
//   console.log('An error occurred while retrieving token. ', err);
//   // ...
// });


Vue.config.productionTip = false
Vue.prototype.$user = store.state.settings.user

Vue.filter('number', function (value) {
  if (value || value == 0)
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  else
    return ''
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js